import React, { useEffect, useState } from 'react';
import * as Tools from '../../helpers/Tools';
import { withTranslation } from 'react-i18next';
import { Button, PasswordWithValidation, TextFieldWithValidation, Password} from "../ecosystem/";

const LoginForm = ({ 
    capsLock,
    errors,
    fields,
    handleUserNameChange,
    handlePasswordChange,
    handleSubmit,
    isClientSide,
    t
}) => {

    const [showCapsLockWrn, setShowCapsLockWrn] = useState(false);
    const isSafari = Tools.isSafari();
    
    return (
        <form 
            id="login-page-form"
            className="row login-form text-left"
            onSubmit={handleSubmit}
            noValidate
        >
            <div className="col-12">
                <TextFieldWithValidation 
                    id="username"
                    name="username"
                    label="Username"
                    autoFocus
                    required
                    value={fields['username']}
                    onChange={e => handleUserNameChange(e)}
                    customValidation={(value) => {
                        return (errors && errors['username'] !== undefined && errors['username'] !== '') ? false : true
                    }}
                    errorMsg={errors['username'] ? errors['username'] : 'Please enter a username'}
                />
            </div>
            <div className="col-12">
                <PasswordWithValidation
                    id="password"
                    name="password"
                    required
                    value={fields['password']}
                    onBlur={(event) => {
                        if (event.relatedTarget?.className !== 'bsw-text-field__clear-btn' &&
                            event.relatedTarget?.className !== 'bsw-text-field__post-icon-btn') {
                            if (showCapsLockWrn)
                                setShowCapsLockWrn(false);
                        }
                    }}
                    onFocus={() => {
                        if (!showCapsLockWrn)
                            setShowCapsLockWrn(true);
                    }}
                    onKeyUp={() => {
                        if (!showCapsLockWrn)
                            setShowCapsLockWrn(true);
                    }}
                    onChange={e => handlePasswordChange(e)}
                    customValidation={(value) => {
                        return (errors && errors['password'] !== undefined && errors['password'] !== '') ? false : true
                    }}
                    errorMsg={errors['password'] ? errors['password'] : 'Please enter a password'}
                    hintMsg={capsLock && showCapsLockWrn ? 'Caps lock is on.' : ''}
                />
            </div>
            <div className="col-12">
                <Button
                    type="submit"
                    value="Log In"
                    disabled={!isClientSide}
                    fluid
                >
                    {"Log in"}
                </Button>
            </div>
        </form> 
    );
};

export default (withTranslation()(LoginForm));